import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Circle from './Circle';
import NumberStat from 'components/atoms/NumberStat/NumberStat';

/**
 *
 * @param {*} props
 */
export default function CirclePercentage(props) {
  const { children, label, value, ...rest } = props;

  return (
    <Circle {...rest} variant="static" value={value}>
      <NumberStat value={`${value}%`} label={label} />
    </Circle>
  );
}

CirclePercentage.propTypes = {};

CirclePercentage.defaultProps = {};
